// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1v-v4","content":"LoadingAlert_content__1b7Uo"};